import axios from 'axios';
import { getAuthorizationHeader, deleteAuthorizationToken } from 'services/authorization_token';
import { getCurrentSubDomain } from 'services/sub_domain';
import { PROTOCOL, API_DOMAIN, DEFAULT_LOCALE, APP_DOMAIN, ACTIVE_GROUP_COOKIE_NAME, BYPASS_MAINTENANCE_COOKIE_NAME, STAGING, DEVELOPMENT } from 'constants';
import { getCookieLocale } from 'contexts/i18n/provider';
import { applicationErrors } from 'components/errors/constants';
import merge from 'lodash/merge';
import sessionStore from 'services/session_store';

const setHeaders = () => {
  const headers = {
    Authorization: getAuthorizationHeader(),
    BrandSlug: getCurrentSubDomain(),
    Locale: window.locale || getCookieLocale() || DEFAULT_LOCALE,
    Accept: 'application/json',
    'x-brand': getCurrentSubDomain(),
  };
  if (sessionStore.get(BYPASS_MAINTENANCE_COOKIE_NAME) === '1') {
    merge(headers, {
      'X-Bypass-Maintenance': true,
    });
  }
  const activeGroupId = sessionStore.get(ACTIVE_GROUP_COOKIE_NAME);
  if (activeGroupId && activeGroupId.length > 0) {
    merge(headers, {
      GroupID: activeGroupId,
    });
  }
  return headers;
};

const instance = axios.create({
  baseURL: `${PROTOCOL}://${API_DOMAIN}`,
});

instance.interceptors.request.use(
  (config) => {
    const headers = setHeaders();
    try {
      const urlParams = new URLSearchParams(window.location.search);
      const noCaptchaValue = urlParams.get('no_captcha');
      if ((STAGING || DEVELOPMENT) && noCaptchaValue && typeof config.url === 'string' && config.url.includes('/sessions')) {
        merge(headers, { NoCaptcha: noCaptchaValue });
      }
    } catch (e) {}
    config.headers = headers;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

instance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 503) {
      if (window.setMaintenance) {
        window.setMaintenance();
      }
    }
    if (error.response && error.response.status === 401) {
      const token = getAuthorizationHeader();
      if (token) {
        deleteAuthorizationToken();
      }
      if (!location.href.includes('/?session_expired')) {
        location.href = `${PROTOCOL}://${APP_DOMAIN}/?session_expired`;
        return Promise.reject(error);
      }
    }

    if (error.response && error.response.status === 404) {
      return Promise.reject(applicationErrors.not_found);
    }

    if (error.response) {
      return Promise.reject(error.response);
    }

    return Promise.reject(error);
  },
);

export default instance;
